export enum SetAgentControlPanelType {
    SET_AGENT_CONTROL_PANEL = "SET_AGENT_CONTROL_PANEL",
}
